<div class="p-inputgroup">
  <input
    type="text"
    pInputText
    id="time"
    [(ngModel)]="value"
    [required]="isRequired"
    [readonly]="readonly"
    [disabled]="disabled"
    [tabindex]="tabindex"
    [name]="name"
    [maxLength]="10"
    (change)="onChangeTime()"
    (focus)="Focused()"/>
  @if (showButton) {
    <button
      pButton
      type="button"
      [disabled]="disabled"
      icon="pi pi-chevron-right"
      label="Now"
      title="Set Current Time"
      (click)="setCurrentTime()">
    </button>
  }
</div>
